import PortalIdParser from 'PortalIdParser';
import { AppContext } from 'in-meeting-experience-ui-components/contexts/app/context';
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hubspotUserEmailSelector, hubspotUserLocaleSelector } from '../slices/auth/selectors';
import { trackerActions } from '../slices/tracker/slice';
const useTrackerInfoListener = () => {
  const dispatch = useDispatch();
  const hubspotUserLocale = useSelector(hubspotUserLocaleSelector);
  const hubspotUserEmail = useSelector(hubspotUserEmailSelector);
  const {
    isPastMeeting
  } = useContext(AppContext);
  const portalId = PortalIdParser.getPortalIdFromPath();
  useEffect(() => {
    if (hubspotUserEmail && portalId) {
      dispatch(trackerActions.setTrackerProperies({
        email: hubspotUserEmail,
        hubId: portalId,
        lang: hubspotUserLocale || 'en'
      }));
      dispatch(trackerActions.triggerReadyState());
    }
  }, [hubspotUserEmail, dispatch, portalId, hubspotUserLocale]);
  useEffect(() => {
    dispatch(trackerActions.setTrackerProperies({
      pastMeeting: isPastMeeting
    }));
  }, [dispatch, isPastMeeting]);
};
export default useTrackerInfoListener;